<template>
  <v-app>
    <!-- sidebar : start -->
    <v-navigation-drawer dark v-model="drawer" app class="elevation-2 theme">
      <v-list v-if="isLoggedIn">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              class="
                title
                ml-4
                text-center
                mb-1
                mt-n1
                font-weight-light
                white--text
              "
            >
              <v-img max-width="250" height="30" src="/lessadmin.png" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />

        <v-subheader class="title mt-3 ml-3 white--text">You</v-subheader>

        <template v-for="(item, index) in menuItems.personal">
          <v-list-item
            :key="index + item.text"
            @click="routeTo(item.path)"
            v-if="roleForSideMenuItems(item)"
          >
            <v-list-item-action>
              <v-icon small style="margin-left: 30px; margin-right: -15px"
                >{{ item.icon }}
              </v-icon>
            </v-list-item-action>
            <div v-if="item.text === 'Home'">
              <v-badge
                offset-y="20"
                offset-x="-3"
                dot
                color="#2bb1d0"
                v-model="outstandingTasks"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }} </v-list-item-title>
                </v-list-item-content>
              </v-badge>
            </div>
            <div v-else>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }} </v-list-item-title>
              </v-list-item-content>
            </div>
          </v-list-item>
        </template>

        <v-subheader class="mt-4 ml-3 title white--text"
          >Your Company
        </v-subheader>

        <template v-for="(item, index) in menuItems.company">
          <v-list-item
            :key="index + item.text"
            @click="routeTo(item.path)"
            v-if="roleForSideMenuItems(item)"
            :class="item.mt ? 'mt-' + item.mt : ''"
          >
            <!-- prettier-ignore -->
            <v-list-item-action>
              <v-icon small style="margin-left:30px; margin-right:-15px">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- sidebar : end -->

    <!-- navigation bar :start -->
    <v-app-bar
      class="elevation-0 font-weight-bold"
      fixed
      app
      style="
        background: #e1e1e1;
        border-bottom: solid #ccc 1px;
        font-family: 'Roboto Slab', serif !important;
      "
    >
      <v-app-bar-nav-icon
        dark
        class="theme-text"
        @click.stop="drawer = !drawer"
      />
      <v-divider inset vertical />
      <v-toolbar-title class="font-weight-light px-3" v-if="companyInfo.name">
        <router-link to="/dashboard" class="header-link">
          <v-avatar v-if="companyInfo.logoUrl" size="36px" class="mr-2 ml-1">
            <v-img alt="Avatar" :src="companyInfo.logoUrl" />
          </v-avatar>
          {{ companyInfo.name }}
        </router-link>
      </v-toolbar-title>
      <v-divider inset vertical v-if="userInfo.username" />
      <v-toolbar-title
        class="font-weight-light ml-3"
        style="margin-bottom: 2px"
      >
        <router-link to="/me" class="header-link" v-text="userInfo.username" />
      </v-toolbar-title>
      <v-spacer />
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            x-large
            v-on="on"
            :class="{
              'my-1 mx-1': $vuetify.breakpoint.mdAndUp,
              'ma-0': $vuetify.breakpoint.smAndDown,
            }"
          >
            <v-avatar size="53" v-if="me.profile_image_url">
              <v-img :src="me.profile_image_url" alt="Profile Image" />
            </v-avatar>
            <v-avatar
              size="53"
              dark
              class="grey lighten-3 headline"
              :style="{ color: getColorFromName(`${userInfo.uid}`) }"
              v-else
            >
              <span>{{ getNameInitials(userInfo.username) }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item class="subtitle-1 font-weight-bold">
            <v-list-item-content>
              {{ userInfo.username }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="body-2 mt-n5">
            <v-list-item-content>
              {{ userRole }}
            </v-list-item-content>
          </v-list-item>
          <v-divider />

          <v-list-item to="/me" class="hovered">
            <v-list-item-title>My profile</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isHR" to="/company" class="hovered">
            <v-list-item-title>Company settings</v-list-item-title>
          </v-list-item>
          <v-list-item  href="https://www.lessadmin.com/terms/terms-and-conditions" target="_blank" class="hovered">
            <v-list-item-title>Terms and conditions</v-list-item-title>
          </v-list-item>
          <v-list-item  href="https://www.lessadmin.com/terms/privacy-policy" target="_blank" class="hovered">
            <v-list-item-title>Privacy policy</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Sign out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- navigation bar : end -->

    <v-main>
      <v-container>
        <v-row>
          <v-col offset-lg="1" lg="10" sm="12" v-if="alertShow">
            <v-alert
              border="left"
              class="mb-n3 py-7 pl-9 elevation-2"
              dismissible
              v-model="alertShow"
              :color="alertType"
              colored-border
              rounded
            >
              <div v-if="alertComponent === 'Registered'">
                You are currently in demo mode. Please
                <a
                  @click="showMembershipForm"
                  class="theme-text font-weight-bold"
                  >activate your membership</a
                >
                to use all features.
              </div>
              <div v-else-if="alertComponent === 'Initiated'">
                Please wait while your card is being processed. Your account
                will be activated shortly.
                <v-spacer></v-spacer>
                <a
                  @click="setup"
                  class="theme-text font-weight-bold float-right mt-n6"
                  >Refresh
                </a>
              </div>
              <div v-else-if="alertComponent === 'Cancelled'">
                Your subscription is cancelled. Please <a
                  @click="showMembershipForm"
                  class="theme-text font-weight-bold"
                  >activate your membership</a
                > to use all features.
                <v-spacer></v-spacer>
              </div>
              <div v-else v-html="alertText" />
            </v-alert>
          </v-col>
          <v-col sm="12">
            <router-view
              v-if="isLoggedIn && countries && userInfo && companyInfo"
              @handleAlert="handleAlert"
              @refresh="handleRefresh"
            />
          </v-col>
        </v-row>
        <v-dialog v-model="dialog" persistent max-width="550">
          <v-card>
            <v-card-title class="theme white--text headline pt-4">
              <v-spacer />
              <span>Please activate your account</span>
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-6 mb-2 text-body-1">
              You need to confirm your email address before you can start using
              LessAdmin. Please check your email and click on the link we have
              sent you. Thanks!
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="action white--text rounded-sm mb-3 ml-1"
                depressed
                @click="logout"
                >Logout</v-btn
              >
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="loggedInDialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline pt-4">
              <v-spacer />
              <span>Your session is invalid</span>
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text class="my-3 text-xs-center">
              There seems to be a problem with your session. Please login again.
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" text @click="logout">Logout</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: "AppShell",
  data: () => ({
    drawer: null,
    alertType: "warning",
    alertShow: false,
    alertText: "",
    alertComponent: "",
    sidebarBackgroundStart: Constants.Background.Start,
    sidebarBackgroundEnd: Constants.Background.End,
    menuItems: Constants.MenuItems,
    dialog: false,
    loggedInDialog: false,
    userRole: "",
  }),
  computed: {
    ...mapGetters([
      "userInfo",
      "isLoggedIn",
      "countries",
      "companyInfo",
      "dashboard",
      "me",
    ]),
    isHR() {
      return this.userInfo.role === Constants.Roles.HR;
    },
    sidebarGradient() {
      return `to top right, ${this.sidebarBackgroundStart}, ${this.sidebarBackgroundEnd}`;
    },
    outstandingTasks() {
      return this.dashboard.todos != null;
    },
  },
  methods: {
    showMembershipForm() {
      this.$router.push({ name: Component.Protected.Company.Membership.List });
    },
    setAlert(show, type, message, component) {
      this.alertType = type;
      this.alertText = message;
      this.alertShow = show ? show : false;
      this.alertComponent = component;
    },
    resetModels() {
      this.setAlert(false, "warning", null, null);
    },
    logout() {
      this.$store.dispatch("logoutUser").then(() => {
        this.dialog = false;
        this.loggedInDialog = false;
        this.$router.replace("/");
      });
    },
    routeTo(path) {
      if (!path) return false;
      this.$router.push({ name: path }).catch(() => {});
    },
    handleAlert(e) {
      if (!e) return false;
      this.setAlert(e.show, e.type, e.message, e.component);
    },
    handleRefresh() {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    },
    role() {
      switch (this.userInfo.role) {
        case Constants.Roles.HR:
          this.userRole = "Admin";
          break;
        default:
          this.userRole = this.userInfo.role;
          break;
      }
    },

    roleForSideMenuItems(item) {
      if (item.role === "all") {
        return true;
      }

      if (
        item.role === Constants.Roles.HR &&
        this.userInfo.role === Constants.Roles.HR
      ) {
        return true;
      }

      return (
        item.role === Constants.Roles.MgrOrHR &&
        (this.userInfo.role === Constants.Roles.HR ||
          this.userInfo.role === Constants.Roles.Manager)
      );
    },

    setup() {
      this.$store.dispatch(Actions.Countries);
      if (this.userInfo.email_verified) {
        this.$store.dispatch(Actions.Employee.Me);
        this.role();
        this.$store
          .dispatch(Actions.Company.Info)
          .then(() => {
            if (this.companyInfo.status !== "Active") {
              this.setAlert(true, "theme", null, this.companyInfo.status);
            }
          })
          .catch(() => (this.loggedInDialog = true));
      } else {
        this.dialog = true;
      }
    },
  },
  created() {
    this.resetModels();
    this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
  },
};
</script>

<style>
.hovered:hover {
  background-color: #f6f6f6;
  cursor: pointer;
}
</style>
